import { StateSlice, Store } from '../type';

export type AppSlice = {};
export const createAppSlice: StateSlice<Store, AppSlice> = (set, get) => ({});
